module.exports = __webpack_public_path__ + "static/media/218-turkey.401c3f7c.svg";